import { TabButton } from './TabButton'
import { BaseTabsProps } from './types'

export function Tabs<T>({
  tabs,
  selectedTab,
  setSelectedTab,
  className = '',
}: BaseTabsProps<T>) {
  return (
    <div className={`flex w-full ${className}`}>
      {tabs.map(({ key, title, badge }) => (
        <TabButton
          key={String(key)}
          title={title}
          badge={badge}
          isActive={selectedTab === key}
          onClick={() => setSelectedTab(key)}
          flexMode="equal"
        />
      ))}
    </div>
  )
}
